<template>
  <div class="indexPageBox">
    <div class="bannerBox">
      <HeaderCom></HeaderCom>
      <swiper ref="mySwiper" :options="swiperOptions" style="height: 520px">
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/product_banner1.png');">
            <div class="banner_item1_content">
              <p>一站式智慧消防平台</p>
              <p class="txt1">用数据+科技的力量创造价值</p>
              <!--<div class="item1_infoBox">-->
              <!--查看详情>-->
              <!--</div>-->
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-02.png');">
            <div class="banner_item1_content">
              <p>云现场远程检查服务系统</p>
              <p class="txt1">
                以双向音视频通话为技术手段，深化了“云端”+“服务”的理念，
                实行对企业的消防远程检查
              </p>
              <div class="item1_infoBox" @click="toCloud()">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-03.png');">
            <div class="banner_item1_content">
              <p>消防物联网解决方案</p>
              <p class="txt1">
                全市安装独立式烟感报警终端35,753台，分布全市养老院、
                独居老人、九小场所等
              </p>
              <div class="item1_infoBox">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-04.png');">
            <div class="banner_item1_content">
              <p>“双随机、一公开”消防监管信息系统</p>
              <p class="txt1">
                深化消防执法改革，创新监管方式，加强事中事后监管，
                规范执法行为，适应新的消防监督检查流程
              </p>
              <div class="item1_infoBox">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="header_product">
        <div class="header_product_content">
          <div class="header_product_navBottom">
            <div>
              <img src="static/image/dingzhi.png" alt="">
            </div>
            <div>
              <span>定制</span>
              <span>根据政府（企业）实际需求，打造极致用户体验，随心定制。</span>
            </div>
          </div>
          <div class="header_product_navBottom">
            <div>
              <img src="static/image/stl.png" alt="">
            </div>
            <div>
              <span>生态链</span>
              <span>智慧安全全产业链整合服务商，智慧安全一站式运营服务提供商。</span>
            </div>
          </div>
          <div class="header_product_navBottom">
            <div>
              <img src="static/image/yth.png" alt="">
            </div>
            <div>
              <span>一体化</span>
              <span>集合物联网采集，互联网管控，云平台服务，大数据分析</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product_section">
      <div class="product_section_box">
        <div class="product_section_deadline">
          截止目前
        </div>
        <div class="product_section_itemBox">
          <div class="product_section_item">
            <div>
              <img src="static/image/gov_company.png" style="width: 126px;height: 105px" alt="">
            </div>
            <div>
              <span>100</span><span>+</span>
            </div>
            <span>合作政府机构</span>
          </div>
          <div class="product_section_item">
            <div>
              <img src="static/image/gov_company.png" style="width: 126px;height: 105px" alt="">
            </div>
            <div>
              <span>3000</span><span>+</span>
            </div>
            <span>合作消防机构</span>
          </div>
          <div class="product_section_item">
            <div>
              <img src="static/image/gov_company.png" style="width: 126px;height: 105px" alt="">
            </div>
            <div>
              <span>1500W</span><span>+</span>
            </div>
            <span>客户单位</span>
          </div>
          <div class="product_section_item">
            <div>
              <img src="static/image/gov_company.png" style="width: 126px;height: 105px" alt="">
            </div>
            <div>
              <span>2000W</span><span>+</span>
            </div>
            <span>系统用户</span>
          </div>
        </div>
      </div>
    </div>
    <div class="government_section">
      <div class="government_section_box">
        <div class="government_section_item1">
          <div>
            <span>政务云平台</span>
            <span>Government Cloud Platform</span>
          </div>
          <div>
            <img src="static/image/ys.png" alt="">
          </div>
        </div>
        <div class="government_section_item3">

        </div>
        <div class="government_section_item4">

        </div>
        <div class="government_section_item2">

          <div class="government_item1" style="background-image: url('static/image/ptll_bg.png')">
            <div class="government_item1_txt1">
              >>>
            </div>
            <div class="government_item1_txt2">
              平台理念
            </div>
            <ul class="government_item1_txt3">
              <li>一体化互联互通智慧安全云平台</li>
              <li>化被动型防控为主动型防控</li>
              <li>人防、物防、技防有机结合</li>
              <li>全员、全体、全时段、全方位预防</li>
              <li>家庭、社区、场所、单位、城市五平安</li>
            </ul>
          </div>
          <div class="government_item2">
            <div class="government_item2_box government_item2_border1" @click="toCloudCheck">
              <div class="government_item2_border4">

              </div>
              <div>
                <img src="static/image/yxc_icon.png" alt="">
              </div>
              <div class="government_item2_txt1">
                云现场远程检察服务系统
              </div>
              <div class="government_item2_txt2">
                在特定场景下，消防检查人员可以通过在线的方式，以双向音视频通话为技术手段，实行对企业的消防远程检查，一边视频对话指导企业现场…
              </div>
            </div>
            <div class="government_item2_box government_item2_border2" @click="toDoubleRandom">
              <div>
                <img src="static/image/suj_icon.png" alt="">
              </div>
              <div class="government_item2_txt1">
                “双随机、一公开”消防监管信息系统
              </div>
              <div class="government_item2_txt2">
                为深化消防执法改革，落实《国务院关于在市场监管领域全面推行部门联合“双随机、一公开”监管的意见》（国发〔2019〕5号）的部署要求…
              </div>
            </div>
            <div class="government_item2_box government_item2_border3" @click="toFirePrevention">
              <div>
                <img src="static/image/fhzhtd_icon.png" alt="">
              </div>
              <div class="government_item2_txt1">
                防火指挥调度系统
              </div>
              <div class="government_item2_txt2">
                防火指挥调度子系统是指由我司提供的，用于帮助南京支队了解各区域火灾风险情况，统一指挥调度现有警力管理各单位的系统；能够对社会单位…
              </div>
            </div>
            <div class="government_item2_box" @click="toMobileFire">
              <div>
                <img src="static/image/ydxfqw_icon.png" alt="">
              </div>
              <div class="government_item2_txt1">
                移动消防勤务系统
              </div>
              <div class="government_item2_txt2">
                移动消防警务平台配合智能消防车，实现九小场所的信息采集、水源采集、安全巡查、教育宣传、灭火救援的功能。在巡查场所张贴绑定单位信息…
              </div>
            </div>
          </div>
          <div class="government_item3_box" @click="toMicroFire">
            <div>
              <img src="static/image/xfws_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              消防微士
            </div>
            <div class="government_item2_txt2">
              微型消防站项目以大数据、云计算、移动互联等新兴技术与传统成熟信息技术相结合为关键支撑，紧贴当前全市微型消防站建设管理中的薄弱环节…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toTipSetting">
            <div>
              <img src="static/image/crb_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              出入保系统
            </div>
            <div class="government_item2_txt2">
              形成城市人群基础大数据，便于管理城市实际人口情况；对人员的数据进行真实性验证，并记录数据的变更情况；跟踪人员轨迹，一旦发生问题…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toInternetControl">
            <div>
              <img src="static/image/xfwlw_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              消防物联网云平台
            </div>
            <div class="government_item2_txt2">
              消防物联网的统一接入平台，实现所有消防物联报警信息的统一汇聚、报警联动处理（报警后电话、短信、微信分级推送、分组监控，统一维保…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toTransportManage">
            <div>
              <img src="static/image/gggl_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              公共管廊智慧管理系统
            </div>
            <div class="government_item2_txt2">
              平台主要由云端服务器、重点部位二维码和智能巡检终端。其中，云端服务器负责向智能巡检终端推送工作任务并存储上报工作记录；智能巡检…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toTipSetting">
            <div>
              <img src="static/image/dhbb_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              动火报备平台
            </div>
            <div class="government_item2_txt2">
              在特定场景下，消防检查人员可以通过在线的方式，以双向音视频通话为技术手段，实行对企业的消防远程检查，一边视频对话指导企业现场…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toCommunicationManage">
            <div>
              <img src="static/image/xungt_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              训管通
            </div>
            <div class="government_item2_txt2">
              训管通软件是依托于市消防局“一中心，三平台”的智慧消防体系架构下的一个子模块，软件的开发遵循“三不”原则，即：“不重复投入硬件资源…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="government_section government_sectionCell">
      <div class="government_section_box">
        <div class="government_section_item1 government_section_item1Cell">
          <div>
            <span>企业云平台</span>
            <span>Enterprise Cloud Platform</span>
          </div>
          <div>
            <img src="static/image/ys.png" alt="">
          </div>
        </div>
        <div class="government_section_item3 government_section_item3Color1">

        </div>
        <div class="government_section_item4 government_section_item3Color">

        </div>
        <div class="government_section_item2">
          <div class="government_item3_box" @click="toTipSetting">
            <div>
              <img src="static/image/wlysw_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              威立雅水务系统
            </div>
            <div class="government_item2_txt2">
              全面实现设备信息和运维管理工作的电子化、网络化，使设备运维管理工作在线可控，并建立统一的设备信息和运维管理数据平台。全面实现统计…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toTipSetting">
            <div>
              <img src="static/image/jldc_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              金陵电厂巡检系统
            </div>
            <div class="government_item2_txt2">
              在特定场景下，消防检查人员可以通过在线的方式，以双向音视频通话为技术手段，实行对企业的消防远程检查，一边视频对话指导企业现场…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toPipeEliminator">
            <div>
              <img src="static/image/xgt_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              社会单位自主管理平台（消管通）
            </div>
            <div class="government_item2_txt2">
              通过“一动” + “四定”原则，为社会单位量身定制的系统化的消防巡检工作方案。重点巡检点位张贴MIP巡查点（绑定地理位置和巡检规范…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toTipSetting">
            <div>
              <img src="static/image/gxxl_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              国信协联二维码巡检系统
            </div>
            <div class="government_item2_txt2">
              在特定场景下，消防检查人员可以通过在线的方式，以双向音视频通话为技术手段，实行对企业的消防远程检查，一边视频对话指导企业现场…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toSafetyResponsibility">
            <div>
              <img src="static/image/azt_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              企业安责通系统
            </div>
            <div class="government_item2_txt2">
              通过建立企业安责通系统，整体解决集团公司及下属各单位安全生产和综合整治的各项工作的信息化管理和基础管理台账资料的电子化，并辅助…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toTipSetting">
            <div>
              <img src="static/image/xfwb_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              消防维保工作平台
            </div>
            <div class="government_item2_txt2">
              全面管辖维保单位相关人员日常维保工作开展情况，釆用“定人、定时、定点、定规范” 的原则以确保一线维保人员工作的真实性，并定期…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
          <div class="government_item3_box" @click="toVideoLinkage">
            <div>
              <img src="static/image/yhssp_icon.png" alt="">
            </div>
            <div class="government_item2_txt1">
              消防隐患随手拍
            </div>
            <div class="government_item2_txt2">
              发动群众力量，参与消防安全工作，建立群众举报积分奖励机制，提高群众参与热度。全 面提高群众的消防安全意识，实现排除消防安全隐患…
            </div>
            <div class="government_item3_txt1">
              产品详情>>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterCom></FooterCom>
  </div>

</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
    export default {
        name: "productPage",
      components: {
        HeaderCom,
        FooterCom
      },
      data(){
          return{
            swiperOptions: {
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              },
              // slidesPerView: 'auto',
              centeredSlides: true,
              autoplay: {
                delay: 2500,
                disableOnInteraction: false
              },
              height:580,
              loop:true,
              observer:true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents:true,//修改swiper的父元素时，自动初始化swiper
              // Some Swiper option/callback...
            },
          }
      },
      methods:{
        toDoubleRandom(){
          this.$router.push({
            name: "DoubleRandom"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toFirePrevention(){
          this.$router.push({
            name: "FirePrevention"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toMobileFire(){
          this.$router.push({
            name: "MobileFire"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toMicroFire(){
          this.$router.push({
            name: "MicroFire"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toInternetControl(){
          this.$router.push({
            name: "InternetControl"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toTransportManage(){
          this.$router.push({
            name: "TransportManage"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toSafetyResponsibility(){
          this.$router.push({
            name: "SafetyResponsibility"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toVideoLinkage(){
          this.$router.push({
            name: "VideoLinkage"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toCommunicationManage(){
          this.$router.push({
            name: "CommunicationManage"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toPipeEliminator(){
          this.$router.push({
            name: "PipeEliminator"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toCloudCheck(){
          window.open("https://xffww.com/admin/#/login")
        },
        toCloud(){
          window.open("https://xffww.com/admin/#/login")
        },
        toTipSetting(){
          this.$message({
            message: '正在建设中......',
            type: 'warning'
          });
        }
      }
    }
</script>

<style scoped>
  .indexPageBox{
    width: 100%;
    box-sizing: border-box;
    color: #ffffff;
    height: 100%;
    min-width: 1200px;
    overflow-x: hidden;
  }
  .bannerBox{
    width: 100%;
    height: 520px;
    box-sizing: border-box;
    position: relative;
  }
  .banner_item{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .banner_item1_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: PingFang-SC-Medium;
  }
  .banner_item1_content p:nth-of-type(1){
    font-size: 42px;
    letter-spacing: 2px;
  }
  .item1_infoBox{
    width:150px;
    height:48px;
    background:rgba(42,98,255,1);
    font-size: 16px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
  .txt1{
    width: 530px;
    box-sizing: border-box;
    padding: 30px 0;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 2px;
  }
  .header_product{
    width: 100%;
    height: 120px;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    z-index: 11;
    background:rgba(255,255,255,0.03);
  }
  .header_product_content{
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/  .el-carousel__indicators.el-carousel__indicators--horizontal{
    bottom: 125px!important;
  }
  .header_product_navBottom{
    box-sizing: border-box;
    display: flex;
  }
  .header_product_navBottom>div{
    box-sizing: border-box;
    padding: 0 0 0 20px;
  }
  .header_product_navBottom>div>img{
    display: inline-block;
    width: 70px;
    height: 70px;
  }
  .header_product_navBottom>div:nth-of-type(2){
    display: flex;
    flex-direction: column;
  }
  .header_product_navBottom>div:nth-of-type(2)>span:nth-of-type(1){
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    padding: 0 0 5px 0;
  }
  .header_product_navBottom>div:nth-of-type(2)>span:nth-of-type(2){
    width:237px;
    height:39px;
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(210,210,210,1);
    line-height:24px;
  }
  .product_section{
    width: 100%;
    height: 660px;
    display: flex;
    justify-content: center;
    background: #fefeff;
  }
  .product_section_box{
    width: 1200px;
  }
  /deep/ .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 140px!important;
  }
  /deep/ .swiper-pagination-bullet{
    width:30px;
    height:2px;
    background:rgba(255,255,255,1);
    border-radius:1px;
  }
  .product_section_deadline{
    width: 100%;
    height: 220px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product_section_itemBox{
    width: 100%;
    display: flex;
  }
  .product_section_item{
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .product_section_item>div:nth-of-type(1){
    width: 122px;
    height: 105px;
  }
  .product_section_item>div:nth-of-type(2){
    box-sizing: border-box;
    padding: 30px 0 25px 0;
  }
  .product_section_item>div:nth-of-type(2)>span:nth-of-type(1){
    font-size:40px;
    font-family:DIN;
    font-weight:500;
    color:rgba(51,51,51,1);
  }
  .product_section_item>div:nth-of-type(2)>span:nth-of-type(2){
    font-size:24px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
  }
  .product_section_item>span{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(153,153,153,1);
  }
  .government_section{
    width: 100%;
    display: flex;
    justify-content: center;
    background:rgba(238,242,254,1);
  }
  .government_sectionCell{
    box-sizing: border-box;
    padding: 120px 0 0 0;
  }
  .government_section_box{
    width: 1200px;
    position: relative;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .government_section_item1{
    position: absolute;
    z-index: 1;
    top: -65px;
    left: -62px;
    width:700px;
    height:700px;
    background:rgba(191,207,255,1);
    border-radius:0 200px 0 200px;
    display: flex;
    box-sizing: border-box;
    padding: 10px 155px 0 60px;
    justify-content: space-between;
  }
  .government_section_item1Cell{
    top: -35px;
    left: -62px;
  }
  .government_section_item1>div:nth-of-type(1){
    display: flex;
    flex-direction: column;
  }
  .government_section_item1>div:nth-of-type(2){
    box-sizing: border-box;
    padding: 28px 0 0 0;
  }
  .government_section_item1>div:nth-of-type(1)>span:nth-of-type(1){
    font-size:36px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    box-sizing: border-box;
    padding:18px 0 10px 0;
  }
  .government_section_item1>div:nth-of-type(1)>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(217,227,255,1);
    padding:0 0 20px 0;
  }
  .government_section_item3{
    width:70px;
    height:70px;
    background:rgba(42,98,255,1);
    border-radius:20px 20px 20px 0;
    position: absolute;
    z-index: 1;
    right: 70px;
    top: -100px;
  }
  .government_section_item3Color1{
    background:rgba(171,192,255,1);
  }
  .government_section_item4{
    width:30px;
    height:30px;
    background:rgba(171,192,255,1);
    position: absolute;
    z-index: 1;
    right: 170px;
    top: -12px;
  }
  .government_section_item3Color{
    background:rgba(42,98,255,1);
  }
  .government_section_item2{
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    z-index: 12;
    flex-wrap: wrap;
  }
  .government_item1{
    width:380px;
    height:460px;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 38px 0 0 30px;
  }
  .government_item1_txt1{
    font-size:36px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(122,152,232,1);
  }
  .government_item1_txt2{
    font-size:36px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    box-sizing: border-box;
    padding: 14px 0 45px 0;
  }
  .government_item1_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    padding: 0 0 0 18px;
    line-height: 36px;
  }
  .government_item2{
    width:790px;
    height:460px;
    background:rgba(255,255,255,1);
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
  }
  .government_item2_box{
    width: 50%;
    height: 50%;
    box-sizing: border-box;
    padding: 30px 0 0 20px;
  }
  .government_item2_border1{
    border-bottom: 1px solid #e3eaff;
    border-right: 1px solid #e3eaff;
    position: relative;
  }
  .government_item2_border2{
    border-bottom: 1px solid #e3eaff;
  }
  .government_item2_border3{
    border-right: 1px solid #e3eaff;
  }
  .government_item2_border4{
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background:rgba(255,255,255,1);
    position: absolute;
    z-index: 1;
    right: -10px;
    bottom: -10px;
  }
  .government_item2_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    box-sizing: border-box;
    padding: 20px 0;
  }
  .government_item2_txt2{
    width:314px;
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(153,153,153,1);
    line-height:22px;
  }
  .government_item2:hover,.government_item3_box:hover{
    box-shadow: 3px 3px 10px #d8e2fe;
    cursor: pointer;
  }
  .government_item3_box{
    width:380px;
    height:290px;
    background:rgba(255,255,255,1);
    box-sizing: border-box;
    margin: 30px 0 0 0;
    padding: 30px;
  }
  .government_item3_txt1{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(42,98,255,1);
    box-sizing: border-box;
    padding: 30px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/productPage.vue